module.exports = __webpack_public_path__ + "static/img/topBg.3ff95c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backStandard/topBg.jpg
// module id = y7k/
// module chunks = 1